import React, { useEffect, useState } from 'react';

import PrdSwiper from '../Swiper/PrdSwiper';
import { fetchProductDetailData } from '../../services/productService';
import closeBtn from '../../assets/images/common/close.png';
import PrdDtlFile from '../../components/Product/PrdDtlFile';

import S from './DetailModal.module.css';
import { isMobile } from '../../config';

const ProdModal = ({ isOpen, onClose, data, imgUrl, curIdx }) => {

  const [ mainImage, setMainImage ] = useState(null);
  const [ newData, setNewData ] = useState([]);
  const [ swiperSlides, setSwiperSlides ] = useState([]);
  
  const reloadProductData = async (infoSeq, curIdx) => {

    const newPopdata = await fetchProductDetailData(infoSeq, curIdx);

    setNewData(newPopdata);
  };

  useEffect(() => {
    if (data.prdListInfo.length > 0) {
      const slides = data.prdListInfo.map(item => ({
        imgUrl: `${imgUrl}${item.INFO_IMG_PATH}`,
        infoSeq: item.INFO_SEQ
      }));
      setSwiperSlides(slides);
    }
  }, [data.prdListInfo, imgUrl]);

  useEffect(() => {
    if(data.images.length > 0) {
      setMainImage(imgUrl + data.images[0]);
    }
  }, []);

  useEffect(() => {
    if (newData) {
      if (newData.images && newData.images.length > 0) {
        setMainImage(imgUrl + newData.images[0]);
      }
  
      if (newData.prdListInfo && newData.prdListInfo.length > 0) {
        const slides = newData.prdListInfo.map(item => ({
          imgUrl: `${imgUrl}${item.INFO_IMG_PATH}`,
          infoSeq: item.INFO_SEQ
        }));
        setSwiperSlides(slides);
      }
    }
  }, [newData]);

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  const handleMainImageClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  
  return (
    <div id={S.detailModalBack} onClick={onClose} style={{ display: isOpen ? 'flex' : 'none' }}>
      <div id={S.detailModalWrapDiv} onClick={handleContentClick}>

        <div id={S.closeBtn} onClick={onClose}><img src={closeBtn}/></div>
        <div id={S.modalWrap}>
          <div id={S.detailModalImageWrap}>
            <div id={S.mainImgDiv}>
              <img id={S.mainImg} alt='main-img' src={mainImage}/>
            </div>
            <div id={S.subImgDiv}>
              {[0, 1, 2].map(index => {
                const image = (newData?.images || data.images)?.[index];
                const className = image ? S.subImg : S.subImgNone;
                return (
                  <div key={index} className={className}>
                    {image && <img src={imgUrl + image} onClick={() => handleMainImageClick(imgUrl + image)}/>}
                  </div>
                );
              })}
            </div>

            {isMobile() ? null : (
              swiperSlides.length > 0 && (
                <>
                  <div className={`fw-700 ${S.linkTitle}`}>다른 상품</div>
                  <div className='pop-line'></div>
                  <div id={S.linkImgList}>
                    <PrdSwiper slides={swiperSlides} onSlideClick={reloadProductData} curIdx={curIdx} />
                  </div>
                </>
              )
            )}
            
          </div>

          <div id={S.detailModalContentWrap}>
            <div className='flex-column fw-700' id={S.conTitle}>{newData?.title || data.title}</div>
            <div className='flex-column fw-700' id={S.conIntro}>{newData?.content || data.content}</div>
            <div className={`flex-row mt-50 ${S.fileBtnDiv}`}>
              {(newData?.files || data.files) && (newData?.files || data.files).map((item, index) => (
                <PrdDtlFile key={index} fileSeq={item.FILE_SEQ} filePath={item.FILE_PATH} fileType={item.FILE_TYPE} />
              ))}
            </div>
            <div id={S.conTableDiv}>
              {(newData?.th || data.th) && (newData?.th || data.th).map((item, index) => (
                <div id={S.conTableCon} key={index}>
                  <div className={S.conTableTh}>{item}</div>
                  <div className={S.conTableTd} dangerouslySetInnerHTML={{ __html: (newData?.td || data.td).length > 0 && (newData?.td || data.td)[index] }}></div>
                </div>
              ))}
            </div>
            
            {isMobile() ? (
              swiperSlides.length > 0 && (
                <>
                  <div className={`fw-700 ${S.linkTitle}`}>다른 상품</div>
                  <div className='pop-line'></div>
                  <div id={S.linkImgList}>
                    <PrdSwiper slides={swiperSlides} onSlideClick={reloadProductData} curIdx={curIdx} />
                  </div>
                </>
              )
            ) : null}
          </div>          
        </div>
      </div>
    </div>
  );

};

export default ProdModal;